import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from "@/components/ui/alert-dialog";
import { Button } from "@/components/ui/button";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { useDeleteServiceAccount } from "../../hooks/use-service-accounts";

interface DeleteServiceAccountDialogProps {
  serviceAccountId: string;
}

export const DeleteServiceAccountDialog = ({ serviceAccountId }: DeleteServiceAccountDialogProps) => {
  const { deleteServiceAccount, loading, error } = useDeleteServiceAccount(serviceAccountId);

  const handleDelete = async () => {
    try {
      await deleteServiceAccount();
      toast.success("Compte de service supprimé avec succès", { style: { color: "#228B22" } });
    } catch {
      toast.error(error?.message || "Une erreur s'est produite");
    }
  };

  return (
    <AlertDialog>
      <AlertDialogTrigger asChild>
        <button
          className="cursor-pointer bg-transparent border-none p-0"
          onClick={(e) => e.stopPropagation()}
          type="button"
        >
          Supprimer
        </button>
      </AlertDialogTrigger>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Supprimer le compte de service</AlertDialogTitle>
          <AlertDialogDescription>
            Êtes-vous sûr de vouloir supprimer ce compte de service ? Cette action est irréversible.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Annuler</AlertDialogCancel>
          {loading ? (
            <Button variant="default" disabled>
              <Loader2 className="mr-2 h-4 w-4 animate-spin" />
              Suppression...
            </Button>
          ) : (
            <AlertDialogAction onClick={handleDelete}>Supprimer</AlertDialogAction>
          )}
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
